/**
 * Application Version
 * Update this file when deploying new versions
 */

export const APP_VERSION = '1.0.0';
export const BUILD_DATE = '2026-02-11';
export const RELEASE_NOTES = {
  '1.0.0': [
    'Fixed multi-tenant invoice duplication issue',
    'Fixed Personal Profile API endpoint',
    'Added automated seeding system',
    'Improved database indexes for better performance'
  ]
};

export default {
  version: APP_VERSION,
  buildDate: BUILD_DATE,
  releaseNotes: RELEASE_NOTES
};
